import { ReactNode, useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

interface AdminLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

export default function AdminLayout({ children, title, subtitle }: AdminLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-rose-50/30" dir="rtl" style={{ fontFamily: "'Heebo', sans-serif" }}>
      <AdminSidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Mobile toggle button */}
      <button
        onClick={() => setSidebarOpen(true)}
        className="fixed top-4 right-4 z-30 md:hidden w-10 h-10 flex items-center justify-center rounded-xl bg-white border-2 border-rose-100 text-rose-400 shadow-md cursor-pointer hover:bg-rose-50 transition-colors"
      >
        <i className="ri-menu-line text-lg"></i>
      </button>

      <div className="md:mr-64">
        <AdminHeader title={title} subtitle={subtitle} />
        <main className="p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
